import type { SessionSnapshot } from '@scrambl/shared/session-scope'
import { SessionChangedError } from '@scrambl/shared/session-scope'

import { RefreshAttemptBudget } from './refresh-attempt-budget'

export type RefreshFailureReason =
  | 'none'
  | 'missing_refresh_token'
  | 'unauthorized'
  | 'transient'

/** Refresh state belongs to one login, including same-account reauthentication. */
export function createRefreshCoordinator(capture: () => SessionSnapshot) {
  const createState = () => ({
    scope: capture(),
    budget: new RefreshAttemptBudget(2, 30_000),
    pending: null as Promise<boolean> | null,
    failure: 'none' as RefreshFailureReason,
    redirected: false,
  })
  let state: ReturnType<typeof createState> | undefined
  function current() {
    if (state) {
      try {
        state.scope.assertCurrent()
        return state
      } catch (error) {
        if (!(error instanceof SessionChangedError)) throw error
      }
    }
    state = createState()
    return state
  }
  return {
    current,
    assertCurrent(expected: ReturnType<typeof createState>) {
      expected.scope.assertCurrent()
      if (current() !== expected) throw new SessionChangedError()
    },
    reset() {
      state = createState()
    },
  }
}
